<template lang="html">
  <header>
    <navbar></navbar>
  </header>
</template>

<script lang="js">
import Navbar from '@/components/parts/navbar';

export default {
  name: 'app-header',
  props: [],
  components: {
    'navbar': Navbar,
  },
  data() {
    return {
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/parts/header.vue